import { CURRENCIES, TCurrency } from "./markets";

// Minor units per major unit, by currency, as the payment APIs send them
// (not the ISO 4217 exponent). Derived from `CURRENCIES`.
const buildMinorUnits = (): Record<string, number> => {
  const units: Record<string, number> = {};

  for (const [code, currency] of Object.entries<TCurrency>(CURRENCIES)) {
    // Absent means unconfirmed, which has to stay absent so callers default.
    if (currency.minorUnits !== undefined) units[code] = currency.minorUnits;
  }

  return units;
};

export const CURRENCY_MINOR_UNITS: Record<string, number> = buildMinorUnits();

/** Assumed for an unlisted currency: cents, like every pre-localisation amount. */
export const DEFAULT_MINOR_UNITS = 100;
